import React from "react";
import { Link } from "react-router-dom";
import { Calendar, Clock, ArrowRight } from "lucide-react";
import { blogPosts, images } from "../mock/mock";
import { PageHero, SectionHeading, CTABanner } from "../components/Common";

const Blog = () => {
  const [featured, ...rest] = blogPosts;
  return (
    <div>
      <PageHero
        eyebrow="Insights & Resources"
        title="The Mid Atlantic Blog"
        subtitle="Expert guidance on contact centre outsourcing, healthcare answering, insurance claims, debt recovery and B2B lead generation."
        image={images.ccMan}
      />

      {/* Featured */}
      <section className="bg-white py-20">
        <div className="max-w-7xl mx-auto px-6">
          <Link to={`/blog/${featured.slug}`} className="group grid lg:grid-cols-2 gap-10 items-center rounded-2xl overflow-hidden">
            <div className="img-zoom rounded-2xl shadow-xl">
              <img src={featured.image} alt={featured.title} className="w-full h-[360px] object-cover rounded-2xl" />
            </div>
            <div>
              <div className="flex items-center gap-3 mb-4">
                <span className="rounded-full bg-gold px-3 py-1 text-[11px] font-bold text-navy-dark uppercase">{featured.category}</span>
                <span className="text-xs text-muted-foreground flex items-center gap-1"><Calendar size={13} /> {featured.date}</span>
              </div>
              <h2 className="font-heading font-extrabold text-navy text-2xl md:text-3xl leading-tight group-hover:text-navy-light transition-colors">
                {featured.title}
              </h2>
              <p className="mt-4 text-muted-foreground leading-relaxed">{featured.excerpt}</p>
              <span className="mt-6 inline-flex items-center gap-2 font-bold text-gold-dark">
                Read article <ArrowRight size={16} />
              </span>
            </div>
          </Link>
        </div>
      </section>

      {/* Grid */}
      <section className="bg-secondary py-20">
        <div className="max-w-7xl mx-auto px-6">
          <SectionHeading eyebrow="Latest Articles" title="More from the blog" />
          <div className="grid md:grid-cols-3 gap-6">
            {rest.map((p) => (
              <Link key={p.slug} to={`/blog/${p.slug}`} className="group bg-white rounded-2xl overflow-hidden border border-border card-lift">
                <div className="img-zoom h-48">
                  <img src={p.image} alt={p.title} className="w-full h-full object-cover" />
                </div>
                <div className="p-6">
                  <div className="flex items-center gap-3 mb-3">
                    <span className="rounded-full bg-secondary px-2.5 py-1 text-[10px] font-bold text-navy uppercase">{p.category}</span>
                    <span className="text-xs text-muted-foreground flex items-center gap-1"><Clock size={12} /> {p.readTime}</span>
                  </div>
                  <h3 className="font-heading font-bold text-navy leading-snug mb-2 group-hover:text-navy-light transition-colors">{p.title}</h3>
                  <p className="text-sm text-muted-foreground leading-relaxed line-clamp-3">{p.excerpt}</p>
                </div>
              </Link>
            ))}
          </div>
        </div>
      </section>

      <CTABanner />
    </div>
  );
};

export default Blog;
